import { Offer } from "../../../lib/types";
import { IOfferingGroup } from "./IOfferingGroup";

export interface IPolicy {
  id: number;
  fromDate: string;
  toDate: string;
  name: string;
  status: number;
  contextId: number;
  typeId: number;
  actionId: number;
  assocTypeId: number;
  assocObjectId: number;
  actorTypeId: number;
  actorId: number;
  info: string;
  dsc: string;
  tenantId: number;
  assocOffering: Offer;
  assocOfferingGroup: IOfferingGroup;
  actorOffering: Offer;
  actorOfferingGroup: IOfferingGroup;
}

export enum PolicyTypeId {
  VALIDATE = 1,
  INTERACTION,
  REQUIRE,
}
